import { render, staticRenderFns } from "./LoginStage.vue?vue&type=template&id=288f6ac2&scoped=true"
import script from "./LoginStage.vue?vue&type=script&lang=js"
export * from "./LoginStage.vue?vue&type=script&lang=js"
import style0 from "./LoginStage.vue?vue&type=style&index=0&id=288f6ac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288f6ac2",
  null
  
)

export default component.exports